import { hasWindow, getCookie } from "@litres/utils";
import type {
  ABTestSerializer,
  IBrowser,
  IVarioqubTests,
  ShortAbonementSerializer,
  ShortLitResSubscriptionSerializer,
  ShortUserSerializerWithCustomSocials,
  SubscriptionAbonementStatusEnum,
} from "@litres-libs/types";
import type { IABVariants, ITrackerConfig } from "./TrackerManager.types";

export const getABdata = (abFromStore: ABTestSerializer[]): IABVariants => {
  return abFromStore.reduce((acc, el) => {
    acc[el.id] = el.group;
    return acc;
  }, {} as IABVariants);
};

export const getUserAbonementStatus = (
  userAbonement: ShortAbonementSerializer
): SubscriptionAbonementStatusEnum => {
  if (userAbonement.is_active && userAbonement.grace_period_start) {
    return "grace";
  } else if (userAbonement.is_active) {
    return "active";
  } else {
    return "inactive";
  }
};
export const getUserSubscriptionStatus = (
  userSubscription: ShortLitResSubscriptionSerializer
): SubscriptionAbonementStatusEnum => {
  if (userSubscription.is_active && userSubscription.grace_period_start) {
    return "grace";
  } else if (userSubscription.is_active) {
    return "active";
  } else {
    return "inactive";
  }
};

interface ITrackerArgs {
  foundationUser: ShortUserSerializerWithCustomSocials & {
    varioqubTests: IVarioqubTests;
  };
  browser: IBrowser;
}

export const getTrackerConfig = ({
  foundationUser,
  browser,
}: ITrackerArgs): ITrackerConfig => ({
  abVariants: getABdata(foundationUser.ab_tests),
  deviceModel: (hasWindow && window.navigator.userAgent) || "",
  host: browser.pda ? "pda" : "web",
  userID: foundationUser.id,
  isTester: foundationUser.is_tester,
  subscriptionUserStatus: {
    subscription: getUserSubscriptionStatus(foundationUser.subscription),
    abonement: getUserAbonementStatus(foundationUser.abonement),
  },
  registrationDate: foundationUser.profile.registered_at || "",
  varioqubUserId:
    foundationUser.varioqubTests.ymabParam || getCookie("_ymab_param"),
  varioqubAbVariants: foundationUser.varioqubTests.testIds,
});
